import { createFileRoute } from "@tanstack/react-router";

import { GoalsPage } from "../../features/goals";

export const Route = createFileRoute("/_auth/goals")({
  component: GoalsPage,
});
